import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {GlobalParentVerificationIsCompletedVo} from '../../common/shared/api/nicolas/GlobalParentVerificationIsCompletedVo';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 글로벌 부모 인증 완료 여부 조회
 *
 * Origin: pageNicolasApi.getGlobalParentVerificationIsCompleted
 * API: GET /auth/v1/parent_verify/is_completed
 */
export async function getAuthParentVerifyIsCompleted(
  verifyUuid: string,
  options?: FetcherOptions
): Promise<ApiResultVo & GlobalParentVerificationIsCompletedVo> {
  const response = await axiosBffFetch(
    '/api/gateway/auth/v1/parent_verify/is_completed',
    {
      method: 'GET',
      params: {
        verify_uuid: verifyUuid,
      },
    },
    options
  );
  return response.data;
}
